import { joinPath } from './common.js';
const createEndpointClient = (basePath, instance, { method, path, errors }) => {
    const handler = async (params) => {
        return await instance.exec(method, joinPath(basePath, path), params, errors);
    };
    handler.isError = (error) => {
        // TODO re-enable when RES-1188 is resolved
        // return error instanceof ClientError && errors.includes(error.code)
        return (typeof error === 'object' &&
            error !== null &&
            errors.includes(error?.code));
    };
    return handler;
};
export default createEndpointClient;
//# sourceMappingURL=createEndpointClient.js.map